import { ActivityType } from './activity-type';
import { ActivityViewType } from './activity-view-type';

export class Activity {
  constructor(
    public hash?: string,
    public name?: string,
    public type?: ActivityType,
    public viewType?: ActivityViewType
  ) { }

  clone() {
    return new Activity(
      this.hash,
      this.name,
      this.type,
      this.viewType
    );
  }

  get typeName() {
    return this.type ? this.type.name : '';
  }

  get viewTypeName() {
    return this.type ? this.viewType.name : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/activity.ts